import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaGraduationCap,
  FaUniversity,
  FaClock,
  FaMoneyBillWave,
  FaStar,
  FaArrowRight,
} from "react-icons/fa";

import ProgrammeFilters from "./HerofilterProg";
import "../Programmes Page/ProgrammesPage.css";
import { categoryBadge } from "../Programmes Page/filterRoutes";

export default function HeroFilters() {
  const [filteredProgrammes, setFilteredProgrammes] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const programmesPerPage = 9;

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredProgrammes]);

  const totalPages = Math.ceil(
    filteredProgrammes.length / programmesPerPage
  );

  const indexOfLastProgramme =
    currentPage * programmesPerPage;

  const indexOfFirstProgramme =
    indexOfLastProgramme - programmesPerPage;

  const currentProgrammes =
    filteredProgrammes.slice(
      indexOfFirstProgramme,
      indexOfLastProgramme
    );

  return (
    <>
      <ProgrammeFilters
        onFilter={(results, searched) => {
          setFilteredProgrammes(results);
          setHasSearched(searched);
        }}
      />

      <section
        className={
          hasSearched
            ? "programmes-section"
            : "programmes-section programmes-section--collapsed"
        }
      >
        <div className="container">

          {hasSearched && (
            <div className="results-count">
              Showing{" "}
              <strong>{filteredProgrammes.length}</strong>{" "}
              Programme
              {filteredProgrammes.length !== 1 && "s"}
            </div>
          )}

          <div className="programmes-grid">

            {!hasSearched ? (

              <div className="search-placeholder" />

            ) : currentProgrammes.length > 0 ? (

              currentProgrammes.map((programme) => (

                <div
                  className="programme-card"
                  key={programme.slug}
                >

                  {programme.featured && (
                    <span className="featured-badge">
                      <FaStar />
                      Featured
                    </span>
                  )}

                  <div className="programme-top">

                    <span className="programme-level">
                      {categoryBadge(programme.qualification || programme.category)}
                    </span>

                    <h3>{programme.title}</h3>

                    {/* {programme.code && (
                      <p className="programme-code">
                        {programme.code}
                      </p>
                    )} */}

                  </div>

                  <div className="programme-details">

                    <div>
                      <FaUniversity />
                      <span>{programme.school}</span>
                    </div>

                    <div>
                      <FaClock />
                      <span>
                        {programme.duration}{" "}
                        {programme.durationType}
                      </span>
                    </div>

                    <div>
                      <FaMoneyBillWave />
                      <span>
                        KES{" "}
                        {Number(programme.fee).toLocaleString()}
                        {programme.feeType && (
                          <em className="fee-type-inline">{programme.feeType}</em>
                        )}
                      </span>
                    </div>

                  </div>

                  <div className="programme-intake">

                    <strong>
                      Available Intakes
                    </strong>

                    <div className="intake-tags">

                      {programme.intake?.map((month) => (
                        <span key={month}>
                          {month}
                        </span>
                      ))}

                    </div>

                  </div>

                  <div className="programme-footer">

                    <Link
                      to={`/programme/${programme.slug}`}
                      className="programme-btn"
                    >
                      View Programme
                      <FaArrowRight />
                    </Link>

                  </div>

                </div>

              ))

            ) : (

              <div className="no-programmes">

                <FaGraduationCap />

                <h3>No Programmes Found</h3>

                <p>
                  No programmes match your search.
                  Try changing the filters above.
                </p>

              </div>

            )}

          </div>

          {hasSearched && totalPages > 1 && (

            <div className="pagination">

              {/* <button
                className="prev-btn"
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage((prev) => prev - 1)
                }
              >
                Previous
              </button> */}

              {Array.from(
                { length: totalPages },
                (_, index) => (

                  <button
                    key={index}
                    className={
                      currentPage === index + 1
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      setCurrentPage(index + 1)
                    }
                  >
                    {index + 1}
                  </button>

                )
              )}

              {/* <button
                className="next-btn"
                disabled={
                  currentPage === totalPages
                }
                onClick={() =>
                  setCurrentPage((prev) => prev + 1)
                }
              >
                Next
              </button> */}

            </div>

          )}

        </div>
      </section>
    </>
  );
}
